import { TemporaryGroupItemForLidarAddPin, LidarResizeHandle } from "../item";
import * as marietta from '../../';
import { SVGSprite } from "../flash/display";
import { Stage } from "../model";
import WebCADUtil from "../util/WebCADUtil";

/**
 * ピン登録用itemcontroller
 * STARTS_LIDAR-2017 追加ピンを取り込む際に倍率補正をしたい
 */
export class ItemControllerLidarAddPin {

    dragObj_T: marietta.webcad.control.parts.ControlPicker;

    dragObj_TL: marietta.webcad.control.parts.ControlPicker;

    dragObj_TR: marietta.webcad.control.parts.ControlPicker;

    dragObj_L: marietta.webcad.control.parts.ControlPicker;

    dragObj_R: marietta.webcad.control.parts.ControlPicker;

    dragObj_B: marietta.webcad.control.parts.ControlPicker;

    dragObj_BL: marietta.webcad.control.parts.ControlPicker;

    dragObj_BR: marietta.webcad.control.parts.ControlPicker;

    x: number;

    y: number;

    rotation: number;

    allBox: marietta.webcad.control.parts.BoundingBox;

    rotator: marietta.webcad.control.parts.ControlRotator;

    public spt: SVGSprite;

    startPoint: marietta.core.Point;

    public emptySpt: SVGSprite;

    /** rotateStart で取得。部屋枠の中心（content ローカル） */
    private _rotatePivotLocalCx = 0;

    private _rotatePivotLocalCy = 0;

    /** ドラッグ開始時の部屋枠中心の図面座標（固定） */
    private _rotatePivotPlanSnapshot: marietta.core.Point | null = null;

    /** コントローラー内側をドラッグして取り込み図面を移動するための操作面 */
    private _moveSurface: SVGRectElement;

    private _isMovingBySurface: boolean = false;

    private _moveLastX: number = 0;

    private _moveLastY: number = 0;

    /** タッチ端末（スマホ・タブレット）かどうか */
    private get isTouchDevice(): boolean {
        const ua = marietta.webcad.WebCADGlobal.userAgentManager;
        return ua.isMobile || ua.isTablet;
    }

    constructor(public target: TemporaryGroupItemForLidarAddPin) {
        this.initMe();
    }

    private initMe() {
        const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.FloorShitaeLayer;

        const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.id = 'controller';

        // 全体のボックス
        this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);
        this.allBox.viewObj.setAttribute('fill', '#ffffff');
        this.allBox.viewObj.setAttribute('opacity', '0.3');

        // 移動用の操作面（コントローラー内側をドラッグして取り込み図面を移動する）
        // allBox は「線」のみで内側に当たり判定がないため、内側全体を覆う透明な rect を用意する。
        // rotator・ピッカーより先に追加し、ハンドル類が前面に残るようにする。
        this._moveSurface = document.createElementNS('http://www.w3.org/2000/svg', 'rect') as SVGRectElement;
        this._moveSurface.setAttribute('id', 'lidarAddPinMoveSurface');
        this._moveSurface.setAttribute('fill', '#ffffff');
        this._moveSurface.setAttribute('fill-opacity', '0');
        this._moveSurface.setAttribute('style', 'pointer-events:all; cursor:move;');
        viewObj.appendChild(this._moveSurface);

        if (this.isTouchDevice) {
            this._moveSurface.addEventListener('touchstart', this.onMoveSurfaceStart, { passive: false });
        } else {
            this._moveSurface.addEventListener('mousedown', this.onMoveSurfaceStart);
        }

        // 回転
        this.rotator = new marietta.webcad.control.parts.ControlRotator(viewObj);
        this.rotator.rotateStartFunc = () => this.rotateStart();
        this.rotator.rotateFunc = this.rotate;

        // ピッカー
        this.dragObj_T = new marietta.webcad.control.parts.ControlPicker(viewObj, 'T');
        this.dragObj_T.moveFunc = this.onMoveControlPicker;
        this.dragObj_T.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_TL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TL');
        this.dragObj_TL.moveFunc = this.onMoveControlPicker;
        this.dragObj_TL.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_TR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TR');
        this.dragObj_TR.moveFunc = this.onMoveControlPicker;
        this.dragObj_TR.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_L = new marietta.webcad.control.parts.ControlPicker(viewObj, 'L');
        this.dragObj_L.moveFunc = this.onMoveControlPicker;
        this.dragObj_L.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_R = new marietta.webcad.control.parts.ControlPicker(viewObj, 'R');
        this.dragObj_R.moveFunc = this.onMoveControlPicker;
        this.dragObj_R.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_B = new marietta.webcad.control.parts.ControlPicker(viewObj, 'B');
        this.dragObj_B.moveFunc = this.onMoveControlPicker;
        this.dragObj_B.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_BL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BL');
        this.dragObj_BL.moveFunc = this.onMoveControlPicker;
        this.dragObj_BL.moveEndFunc = this.onMoveEndControlPicker;
        this.dragObj_BR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BR');
        this.dragObj_BR.moveFunc = this.onMoveControlPicker;
        this.dragObj_BR.moveEndFunc = this.onMoveEndControlPicker;

        tarLayer.viewObj.appendChild(viewObj);

        this.spt = new SVGSprite(viewObj);

        // ターゲットに合わせてサイズ変更
        this.resizeToTarget();
    }

    private onMoveControlPicker = (e: MouseEvent = null, target: marietta.webcad.control.parts.ControlPicker) => {
        // 開始時のアイテム場所保持
        if (this.startPoint === undefined || isNaN(this.emptySpt?.mouseX) || isNaN(this.emptySpt?.mouseY)) {

            if (this.emptySpt === undefined || isNaN(this.emptySpt.mouseX) || isNaN(this.emptySpt.mouseY)) {
                /*
                    本来はtarget.sptのmouseX/mouseYで取得できるが、
                    拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
                    そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
                    取得している。
                */
                this.emptySpt = new SVGSprite(null, true);
                this.emptySpt.setEmptyParam(this.target.spt);
                this.target.spt.parent.addChild(this.emptySpt);
            }

            this.startPoint = new marietta.core.Point(
                this.emptySpt.mouseX * this.target.spt.scaleX,
                this.emptySpt.mouseY * this.target.spt.scaleY,
            );

            // added k.kubonaka (WEBCAD-1020対応)
            this.resizeToTarget();
        }

        const newPoint: marietta.core.Point = new marietta.core.Point(
            this.emptySpt.mouseX * this.target.spt.scaleX,
            this.emptySpt.mouseY * this.target.spt.scaleY,
        );

        // アイテムの角度分、座標変換を行う
        const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
        const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
        const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);

        newPoint.x = xx;
        newPoint.y = yy;

        // 他のピッカーの制限
        switch (target) {
            case this.dragObj_T:
                if (this.dragObj_B.y - 10 < newPoint.y) newPoint.y = this.dragObj_B.y - 10;
                break;
            case this.dragObj_B:
                if (this.dragObj_T.y + 10 > newPoint.y) newPoint.y = this.dragObj_T.y + 10;
                break;
            case this.dragObj_L:
                if (this.dragObj_R.x - 10 < newPoint.x) newPoint.x = this.dragObj_R.x - 10;
                break;
            case this.dragObj_R:
                if (this.dragObj_L.x + 10 > newPoint.x) newPoint.x = this.dragObj_L.x + 10;
                break;
            case this.dragObj_TL:
                if (this.dragObj_B.y - 10 < newPoint.y) newPoint.y = this.dragObj_B.y - 10;
                if (this.dragObj_R.x - 10 < newPoint.x) newPoint.x = this.dragObj_R.x - 10;
                break;
            case this.dragObj_TR:
                if (this.dragObj_B.y - 10 < newPoint.y) newPoint.y = this.dragObj_B.y - 10;
                if (this.dragObj_L.x + 10 > newPoint.x) newPoint.x = this.dragObj_L.x + 10;
                break;
            case this.dragObj_BL:
                if (this.dragObj_T.y + 10 > newPoint.y) newPoint.y = this.dragObj_T.y + 10;
                if (this.dragObj_R.x - 10 < newPoint.x) newPoint.x = this.dragObj_R.x - 10;
                break;
            case this.dragObj_BR:
                if (this.dragObj_T.y + 10 > newPoint.y) newPoint.y = this.dragObj_T.y + 10;
                if (this.dragObj_L.x + 10 > newPoint.x) newPoint.x = this.dragObj_L.x + 10;
                break;
            default:
                break;
        }

        // ドラッグ範囲
        switch (target) {
            case this.dragObj_T:
            case this.dragObj_B:
                target.moveY(newPoint.y);
                break;
            case this.dragObj_L:
            case this.dragObj_R:
                target.moveX(newPoint.x);
                break;
            default:
                target.move(newPoint.x, newPoint.y);
                break;
        }

        // 他のピッカーの整理
        switch (target) {
            case this.dragObj_T:
                this.dragObj_TR.moveY(target.y);
                this.dragObj_TL.moveY(target.y);
                break;
            case this.dragObj_B:
                this.dragObj_BR.moveY(target.y);
                this.dragObj_BL.moveY(target.y);
                break;
            case this.dragObj_L:
                this.dragObj_TL.moveX(target.x);
                this.dragObj_BL.moveX(target.x);
                break;
            case this.dragObj_R:
                this.dragObj_TR.moveX(target.x);
                this.dragObj_BR.moveX(target.x);
                break;
            case this.dragObj_TL:
                this.dragObj_L.moveX(target.x);
                this.dragObj_BL.moveX(target.x);
                this.dragObj_TR.moveY(target.y);
                this.dragObj_T.moveY(target.y);
                break;
            case this.dragObj_TR:
                this.dragObj_R.moveX(target.x);
                this.dragObj_BR.moveX(target.x);
                this.dragObj_TL.moveY(target.y);
                this.dragObj_T.moveY(target.y);
                break;
            case this.dragObj_BL:
                this.dragObj_L.moveX(target.x);
                this.dragObj_TL.moveX(target.x);
                this.dragObj_BR.moveY(target.y);
                this.dragObj_B.moveY(target.y);
                break;
            case this.dragObj_BR:
                this.dragObj_R.moveX(target.x);
                this.dragObj_TR.moveX(target.x);
                this.dragObj_BL.moveY(target.y);
                this.dragObj_B.moveY(target.y);
                break;
            default:
                break;
        }
        this.rotator.move(this.dragObj_T.x - 6.5, this.dragObj_T.y - 25);

        // 中点の再配置
        switch (target) {
            case this.dragObj_T:
            case this.dragObj_B:
                this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
                this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
                break;
            case this.dragObj_L:
            case this.dragObj_R:
                this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
                this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
                break;
            default:
            case this.dragObj_TL:
            case this.dragObj_TR:
            case this.dragObj_BL:
            case this.dragObj_BR:
                this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
                this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
                this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
                this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
                break;
        }

        // 矩形のサイズ変更
        const rect = {
            x: this.dragObj_BL.x,
            y: this.dragObj_BL.y,
            width: (this.dragObj_BR.x - this.dragObj_BL.x),
            height: (this.dragObj_BR.y - this.dragObj_TR.y),
        };
        this.allBox.resize(rect);

        this.allBox.move(
            this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2,
            this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2
        );

        // ターゲットのリサイズ（ドラッグ中のハンドルに合わせて反対側を固定）
        this.resizeTarget(target);
    }

    /** ControlPicker 実体からリサイズハンドル種別を得る */
    private resizeHandleFromPicker(picker: marietta.webcad.control.parts.ControlPicker): LidarResizeHandle {
        if (picker === this.dragObj_T) return 'T';
        if (picker === this.dragObj_B) return 'B';
        if (picker === this.dragObj_L) return 'L';
        if (picker === this.dragObj_R) return 'R';
        if (picker === this.dragObj_TL) return 'TL';
        if (picker === this.dragObj_TR) return 'TR';
        if (picker === this.dragObj_BL) return 'BL';
        return 'BR';
    }

    /**
     * コントロールピッカーのドラッグ終了
     */
    private onMoveEndControlPicker() {
        this.startPoint = undefined;

        if (this.emptySpt && this.emptySpt.parent) {
            this.emptySpt.parent.removeChild(this.emptySpt);
            this.emptySpt = undefined;
        }
    }

    /**
     * 移動操作面のドラッグ開始
     * キャンバスのパン（LayerGroup の con の touchstart/mousedown）へ伝播させないよう stopPropagation する。
     */
    private onMoveSurfaceStart = (e: MouseEvent | TouchEvent) => {
        e.stopPropagation();
        if (this.isTouchDevice) e.preventDefault();

        const point = WebCADUtil.getEventClientPoint(e);
        this._moveLastX = point.x;
        this._moveLastY = point.y;
        this._isMovingBySurface = true;

        if (this.isTouchDevice) {
            document.addEventListener('touchmove', this.onMoveSurfaceDrag, { passive: false });
            document.addEventListener('touchend', this.onMoveSurfaceEnd, { passive: false });
        } else {
            document.addEventListener('mousemove', this.onMoveSurfaceDrag);
            document.addEventListener('mouseup', this.onMoveSurfaceEnd);
        }
    };

    /**
     * 移動操作面のドラッグ中：画面(px)の移動量をステージ座標に変換してターゲットを移動
     */
    private onMoveSurfaceDrag = (e: MouseEvent | TouchEvent) => {
        if (!this._isMovingBySurface) return;

        // 2本指以上はピンチ/パン操作とみなし、移動ドラッグを中断（衝突させない）
        const touchEvent = e as TouchEvent;
        if (touchEvent.touches && touchEvent.touches.length >= WebCADUtil.MULTI_TOUCH_FINGER_COUNT) {
            this.onMoveSurfaceEnd();
            return;
        }

        if (this.isTouchDevice) e.preventDefault();

        const stage = marietta.webcad.WebCADGlobal.layerGroup?.spt;
        const sx = stage?.scaleX ?? 1;
        const sy = stage?.scaleY ?? 1;

        const point = WebCADUtil.getEventClientPoint(e);
        const dx = (point.x - this._moveLastX) / sx;
        const dy = (point.y - this._moveLastY) / sy;

        this.target.move(this.target.spt.x + dx, this.target.spt.y + dy);
        // 本体ドラッグ側（TemporaryGroupItemForLidarAddPin.addMoveEvent）と追従処理を揃える
        this.resizeToTarget();

        this._moveLastX = point.x;
        this._moveLastY = point.y;
    };

    /**
     * 移動操作面のドラッグ終了
     */
    private onMoveSurfaceEnd = () => {
        this._isMovingBySurface = false;
        document.removeEventListener('mousemove', this.onMoveSurfaceDrag);
        document.removeEventListener('mouseup', this.onMoveSurfaceEnd);
        document.removeEventListener('touchmove', this.onMoveSurfaceDrag);
        document.removeEventListener('touchend', this.onMoveSurfaceEnd);
    };

    /**
     * 回転の開始（位置のリセット）
     */
    rotateStart = () => {
        this.x = this.target.spt.x;
        this.y = this.target.spt.y;
        this.rotation = this.target.spt.rotation;
        this.updateTransforms();

        const { cx, cy, width, height } = this.target.measureRoomsFrameForController();
        this._rotatePivotLocalCx = cx;
        this._rotatePivotLocalCy = cy;
        this._rotatePivotPlanSnapshot = this.target.contentLocalToPlanPoint(cx, cy);
        this.layoutControlPickers(cx, cy, width, height);

        this.rotation = this.target.spt.rotation;
        this.updateTransforms();
    };

    /**
     * 回転する
     */
    rotate = (e: MouseEvent) => {
        const firstPoint: marietta.core.Point = this._rotatePivotPlanSnapshot
            ?? this.target.contentLocalToPlanPoint(this._rotatePivotLocalCx, this._rotatePivotLocalCy);
        const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
        const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);

        // レイヤーのスケーリング分を考慮
        const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
        secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
        secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
        secondPoint.x /= root.scaleX;
        secondPoint.y /= root.scaleY;

        // 角度
        const radian: number = Math.atan2((firstPoint.x - secondPoint.x), (firstPoint.y - secondPoint.y));
        let angle: number = -radian / (Math.PI / 180) + 360;
        const unit: number = 45;

        if (angle % unit > 5 && angle % unit < unit - 5) {
            this.rotator.showAssist(false);
        } else {
            this.rotator.showAssist(true);
            angle = Math.round(angle / unit) * unit;
        }

        const pivotSnap = this._rotatePivotPlanSnapshot;
        if (pivotSnap) {
            const th = (angle * Math.PI) / 180;
            const cos = Math.cos(th);
            const sin = Math.sin(th);
            const lx = this._rotatePivotLocalCx;
            const ly = this._rotatePivotLocalCy;
            const rx = cos * lx - sin * ly;
            const ry = sin * lx + cos * ly;
            this.target.move(pivotSnap.x - rx, pivotSnap.y - ry);
        }

        this.target.rotate(angle);

        this.x = this.target.spt.x;
        this.y = this.target.spt.y;
        this.rotation = angle;
        this.updateTransforms();

        if (this.emptySpt) {
            this.emptySpt.setEmptyParam(this.target.spt);
        }
    }

    /**
     * ターゲットにシンクロする
     */
    syncMeToTarget() {
        this.x = this.target.spt.x;
        this.y = this.target.spt.y;
        this.rotation = this.target.spt.rotation;
        this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
        this.spt.x = this.x;
        this.spt.y = this.y;
        this.spt.rotation = this.rotation;
        this.spt.update();
    }

    /** 計測したフレーム（中心 cx,cy・サイズ）にピッカーと allBox を配置 */
    private layoutControlPickers(cx: number, cy: number, width: number, height: number) {
        const w = width;
        const h = height;
        this.dragObj_T.move(cx, cy - h / 2);
        this.dragObj_TL.move(cx - w / 2, cy - h / 2);
        this.dragObj_TR.move(cx + w / 2, cy - h / 2);
        this.dragObj_L.move(cx - w / 2, cy);
        this.dragObj_R.move(cx + w / 2, cy);
        this.dragObj_B.move(cx, cy + h / 2);
        this.dragObj_BL.move(cx - w / 2, cy + h / 2);
        this.dragObj_BR.move(cx + w / 2, cy + h / 2);
        this.rotator.move(cx - 6.5, cy - h / 2 - 25);
        this.allBox.resize({ width: w, height: h });
        this.allBox.move(cx, cy);

        // 移動操作面を枠に合わせて配置（allBox と同じ中心・サイズ）
        if (this._moveSurface) {
            this._moveSurface.setAttribute('x', `${cx - w / 2}`);
            this._moveSurface.setAttribute('y', `${cy - h / 2}`);
            this._moveSurface.setAttribute('width', `${w}`);
            this._moveSurface.setAttribute('height', `${h}`);
        }
    }

    /**
     * ターゲットに合わせて各種パーツリサイズ
     */
    resizeToTarget() {
        this.syncMeToTarget();

        const { cx, cy, width, height } = this.target.measureRoomsFrameForController();
        this.layoutControlPickers(cx, cy, width, height);

        this.rotation = this.target.spt.rotation;
        this.updateTransforms();
    }

    /**
     * ターゲットのリサイズ
     */
    private resizeTarget(picker: marietta.webcad.control.parts.ControlPicker) {
        const w: number = this.allBox.width;
        const h: number = this.allBox.height;

        const handle = this.resizeHandleFromPicker(picker);
        // ハンドルごとに反対側をアンカーにするため keepCenter は changeSize 内でオフ
        this.target.changeSize(w, h, true, handle);

        if (this.emptySpt !== undefined) {
            this.emptySpt.width = w;
            this.emptySpt.height = h;
        }

        // recenter は走らないが、位置・回転は target と常に一致させる（図面ドラッグ等とのずれ防止）
        this.syncMeToTarget();
    }

    private createTestDot(x: number, y: number) {
        const dot = document.createElementNS('http://www.w3.org/2000/svg', "circle");
        dot.setAttribute("cx", `${x}`);
        dot.setAttribute("cy", `${y}`);
        dot.setAttribute("r", "6");
        dot.setAttribute("fill", "#ff3b30");
        dot.setAttribute("stroke", "#111");
        dot.setAttribute("stroke-width", "1");
        this.spt.element.appendChild(dot);
    }
}